
import React from 'react';
import ZNetwork from "./znetwork.js";
import ZUtil from "./zutil.js";
import ZProps from "./zprops.js";
import PleaseStandBy from "./PleaseStandBy.js";
import { APP } from "./App.js";
import AMC from "./AMC.js";
import { ROUTER } from "./AMCRouter.js";
import { ZooSearchPageServiceResult } from './ZooSearchPage';
import ZooUserPage from './ZooUserPage';
import ZooUserAnnualActivity from './ZooUserAnnualActivity';

export default class ZooUserProfilePage extends React.Component {
	constructor(props) {
		super(props);
		this.state = { selected: this.props.tab || "profile" };
	}
	componentDidMount() {
		let { target_user_uri } = this.props;
		var me = ZProps.get("user");
		if (target_user_uri && me.uri !== target_user_uri) {
			AMC.getUser(target_user_uri, (err) => {
				if (err) {
					APP.setError("That user does not exist");
					return ROUTER.pushRoute("/");
				}
				this.setState({ user: ZProps.get(target_user_uri), usersettings: ZProps.get(target_user_uri + ".settings") });
			});
		} else {
			this.setState({ user: me, usersettings: ZProps.get("usersettings") });
		}
		this.onSelectTab(this.props.selected || this.state.selected);
	}
	onSelectTab(label) {
		var self = this;
		label = label.toLowerCase();
		switch (label) {
			case "edit" :
				return ROUTER.pushRoute("/account");
			case "likes" :
				ZNetwork.get("relations", "like", this.props.target_user_uri || ZProps.get("user").uri, function(err, liked_things) {
					self.setState({ list: liked_things || [] });
				});
				break;
			case "stars" :
				ZNetwork.get("relations", "star", this.props.target_user_uri || ZProps.get("user").uri, function(err, starred_things) {
					self.setState({ list: starred_things || [] });
				});
				break;
			case "portfolio" :
				ZNetwork.get("things", this.props.target_user_uri || ZProps.get("user").uri, function(err, things) {
					self.setState({ list: things || [] });
				});
				break;
			default:
				break;
		}
		this.setState({selected: label});
	}
	onDelete(uri, e) {
		ZUtil.absorbEvent(e);
		APP.areYouSure(() => {
			ZNetwork.post("destroy", uri, null, null, (err) => {
				this.onSelectTab("profile");
			});
		});
	}
	render() {
		let { target_user_uri } = this.props;
		let { selected, user, usersettings, list } = this.state;
		let is_me = user && ZProps.get("user").uri === user.uri;
		let payload;
//					{ is_me ? '' : <ZooFollowUserButton user={user} /> }
		if (!user) {
			return <PleaseStandBy />;
		}
		if (selected !== "profile") {
			payload = [];
			list = list || [];
			for (let i = 0; i < list.length; ++i) {
				payload.push( <ZooSearchPageServiceResult key={i} item={list[i]} removable={is_me ? this.onDelete.bind(this): null} /> );
			}
		} else {
			payload = <div className="ZooUserPageProfile">
				<header>{user.uri}</header>
				{ ["name", "created_at"].map( prop => {
					if (user[prop]) {
						let value = user[prop];
						if (prop === "created_at") {
							const date_options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
							value = new Date(user[prop]).toLocaleDateString(undefined, date_options);
							prop = "joined";
						}
						return <div key={prop}><span className="ZooUserPageLabel">{prop}:</span> <span className="ZooUserPageValue">{value}</span></div>
					} else {
						return null;
					}
				}) }
				{ ["twitter", "linkedin", "github", "website"].map( prop => {
console.log("prop=" + prop + ", usersettings[prop]=" + usersettings[prop]);
					if (usersettings[prop]) {
						return <div key={prop}><span className="ZooUserPageLabel">{prop}:</span> <span className="ZooUserPageValue"><a href={usersettings[prop]} target="_blank" rel="noopener noreferrer">{usersettings[prop]}</a></span></div>
					} else {
						return null;
					}
				}) }
				{ ["organization", "occupation", "country"].map( prop => {
console.log("2 prop=" + prop + ", usersettings[prop]=" + usersettings[prop]);
					if (usersettings[prop]) {
						return <div key={prop}><span className="ZooUserPageLabel">{prop}:</span> <span className="ZooUserPageValue">{usersettings[prop]}</span></div>
					} else {
						return null;
					}
				}) }
				<header>{new Date().getFullYear()} Contributions</header>
				<ZooUserAnnualActivity user_uri={user.uri} />
				<header>Bio</header>
				<div className="ZooUserPageBio">{usersettings.bio}</div>
			</div>
		}
		return (
			<ZooUserPage key={target_user_uri} user={user} usersettings={usersettings} tabs={["Profile", "Portfolio", "Likes", "Stars"]} rightsides={is_me ? ["Edit"] : ''} selected={selected} onSelectTab={this.onSelectTab.bind(this)}>
				{payload}
			</ZooUserPage>
		);

	}
}



// WEBPACK FOOTER //
// ./src/ZooUserProfilePage.js